import Vue from 'vue';
import store from './../../store'


export default async function navigationMiddleware(to, from, next) {

  store.commit('app/setLastRoute', from)

  next()
}